module.exports = __webpack_public_path__ + "img/title.ad83f6cb.png";